export default __webpack_public_path__ + "static/media/lady.2c54ef6a.png";